<style src="./Proposal.scss" lang="scss" scoped></style>
<template>
  <section class="proposal">
    <content-header path="Cadastro"/>

    <form v-on:submit.prevent="generateProposal">
      <section class="row">
        <section class="col-6">
          <section class="row">
            <dropdown
              label="Tipo"
              placeholder="Escolha..."
              v-model="proposalSheetInfo.proposalConfig.type"
              class="col-12"
              :list-data="listType"/>
            <dropdown
              label="Modelo"
              placeholder="Escolha..."
              v-model="proposalSheetInfo.proposalConfig.model"
              class="col-12"
              :list-data="listModel"/>
            <datebox
              label="Data da Proposta"
              placeholder="10/10/2018"
              class="col-12"
              v-model="proposalSheetInfo.proposalInfo.dateCreated" />

          </section>
        </section>
        <section class="col-6">
          <section class="row">
            <textbox
            label="Lote"
            placeholder="Coluna do Lote"
            class="col-4"
            v-model="proposalSheetInfo.columnLot" />

            <textbox
            label="Item"
            placeholder="Coluna do Item"
            class="col-4"
            v-model="proposalSheetInfo.columnItem" />

            <textbox
            label="Descrição"
            placeholder="Coluna da Descrição"
            class="col-4"
            v-model="proposalSheetInfo.columnDescription" />

          </section>
          <section class="row">
            <textbox
            label="Quantidade"
            placeholder="Coluna da Quantidade"
            class="col-4"
            v-model="proposalSheetInfo.columnQuantity" />

            <textbox
            label="Unidade"
            placeholder="Coluna da Unidade"
            class="col-4"
            v-model="proposalSheetInfo.columnUnity" />

            <textbox
            label="Valor Unitário"
            placeholder="Coluna do Valor Unitário"
            class="col-4"
            v-model="proposalSheetInfo.columnUnitValue" />
          </section>
          <section class="row">
            <textbox
            label="Valor Total"
            placeholder="Coluna do Valor Total"
            class="col-4"
            v-model="proposalSheetInfo.columnTotalValue" />

            <textbox
            label="Marca"
            placeholder="Coluna da marca"
            class="col-4"
            v-model="proposalSheetInfo.columnLab" />
          </section>
        </section>
      </section>

      <form-file-input :formData="proposalSheetInfo"/>
    </form>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import FormFileInput from './components/form-file-input/FormFileInput'
import { Textbox, Dropdown, Datebox } from '@/components/primitives'
import GetProposalInfo from '@/brain/event/GetProposalInfo'
import DateBR from '@/components/primitives/helpers/filters/DateBR'

export default {
  name: 'Proposal',
  components: {
    ContentHeader,
    FormFileInput,
    Textbox,
    Dropdown,
    Datebox
  },
  data () {
    return {
      proposalSheetInfo: {
        columnLot: 'A',
        columnItem: 'B',
        columnDescription: 'D',
        columnQuantity: 'I',
        columnUnity: 'J',
        columnUnitValue: 'X',
        columnTotalValue: 'Y',
        columnLab: 'Z',
        proposalConfig: {
          type: 'PP',
          model: 'LINEA',
          lot: false
        },
        proposalInfo: {
          dateCreated: '',
          clientFullName: 'Pref',
          processInfo: [],
          proposalTotal: 0
        }
      },
      listType: [
        { text: 'PREGÃO PRESENCIAL', value: 'PP' },
        { text: 'ESTIMATIVA', value: 'EST' }
      ],
      listModel: [
        { text: 'LINEA', value: 'LINEA' }
      ]
    }
  },
  mounted () {
    this.getProposalInfo()
  },
  methods: {
    getProposalInfo () {
      const { _id } = this.$store.getters['Events/GET_EVENT_DETAILS']
      GetProposalInfo({ eventId: _id })
        .then((eventInfo) => {
          this.proposalSheetInfo.proposalConfig.lot = eventInfo.lot
          this.proposalSheetInfo.proposalInfo.dateCreated = DateBR(eventInfo.dateCreated)
          this.proposalSheetInfo.proposalInfo.clientFullName = eventInfo.clientFullName
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-detail/proposal/Proposal.vue